import {
  isEthereumAddress,
  isEthereumTransactionHash,
  isBitcoinAddress,
  isBitcoinTransactionHash,
  isTronAddress,
  isTronTransactionHash,
} from './crypto';

export const getPath = (txHashOrAddress: string): string => {
  if (isEthereumTransactionHash(txHashOrAddress)) {
    return `/ethereum/transaction/${txHashOrAddress}`;
  }

  if (isEthereumAddress(txHashOrAddress)) {
    return `/ethereum/address/${txHashOrAddress}`;
  }

  if (isBitcoinAddress(txHashOrAddress)) {
    return `/bitcoin/address/${txHashOrAddress}`;
  }

  if (isBitcoinTransactionHash(txHashOrAddress)) {
    return `/bitcoin/transaction/${txHashOrAddress}`;
  }

  if (isTronAddress(txHashOrAddress)) {
    return `/tron/address/${txHashOrAddress}`;
  }

  if (isTronTransactionHash(txHashOrAddress)) {
    return `/tron/transaction/${txHashOrAddress}`;
  }

  return `/unknown/address/${txHashOrAddress}`;
};

export const getRootTreeUrl = (address: string | undefined) => {
  const baseUrl = 'http://adhoc-hwasoo.elementus-internal.io';
  if (!address) {
    return `${baseUrl}/find_root`;
  }

  const url = `${baseUrl}/find_root?address=${address}`;
  return url;
};
